import React from 'react';
import Table from "../../../common/table/table";
import ShopTimeEntryMissingTimeTable from "./shopTimeEntryMissingTimeTable.js";
import MessageEmptyData from "../../../common/messageEmptyData";

/**
 * ShopTimeEntryMissingTimeTable component
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ShopTimeEntryMissingTimeBody = (prop) => {
    const {filters, tableData} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <Table
                columns={ShopTimeEntryMissingTimeTable()}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'shop_time_entry_missing_time'}
                withGlobalSearch={true}
                scrollable={true}
            />
        </div>
    );
}

export default ShopTimeEntryMissingTimeBody;
